<template>
  <section >

    <b-tabs v-model="activeTab" type="is-toggle" style="padding:20px;">
      <b-tab-item :label="`All (${soilTestsRequests.length})`">
        <orders-table :data="soilTestsRequests" :isLoading="isLoading" @reloadOrders="getSoilTestRequests" :show-status="true">
        </orders-table>
      </b-tab-item>
      <b-tab-item :label="`Pending (${pendingSoilTestsRequests.length})`">
        <orders-table :data="pendingSoilTestsRequests" :isLoading="isLoading" @reloadOrders="getSoilTestRequests" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Approved (${approvedSoilTestsRequests.length})`">
        <orders-table :data="approvedSoilTestsRequests" :isLoading="isLoading" @reloadOrders="getSoilTestRequests" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Cancelled (${cancellededSoilTestsRequests.length})`">
        <orders-table :data="cancellededSoilTestsRequests" :isLoading="isLoading" @reloadOrders="getSoilTestRequests" :show-status="true">
        </orders-table>
      </b-tab-item>


    </b-tabs>
  </section>
</template>

<script>
  import OrdersTable from '@/components/SoilTests/Table';
  import FilterComponent from '@/components/Shared/Filters';
  import { mapActions, mapGetters } from "vuex";
  import {
    mdy
  } from '@/helpers';
  export default {
    name: "soilTestsRequests",
    components: {
      OrdersTable,
      FilterComponent,
      d:           ['PENDING','CANCELLED', 'APPROVED']

    },
    computed: {
      ...mapGetters([
        'drivers'
      ]),

      filters() {
        return this.$store.getters.filters;
      },
      pendingSoilTestsRequests() {
        return this.soilTestsRequests.filter(order => order.status == "PENDING");
      },
      approvedSoilTestsRequests() {
        return this.soilTestsRequests.filter(order => order.status == "ACCEPTED");
      },
      cancellededSoilTestsRequests() {
        return this.soilTestsRequests.filter(order => order.status == "CANCELLED");
      },
    },
    data() {
      return {
        soilTestsRequests: [],
        equipmentTypes: [],
        activeTab: 0,
        isLoading: false,
        filter: this.filters,
      }
    },
    created() {
      this.getSoilTestRequests(this.filters)
    },
    methods: {
      ...mapActions([
        'getDrivers'
      ]),
      getSoilTestRequests(filters = this.filters) {
        this.orders = [];
        this.isLoading = true;

        this.$store.dispatch('getSoilTestRequests', filters).then(soilTestsRequests => {
          this.isLoading = false;
          this.soilTestsRequests = soilTestsRequests
          console.log(soilTestsRequests)
        }).catch(e => {
          console.log(`Exception when getting equipment requests, e:${e}`);
          this.isLoading = false;
        })
      },
    
      applyFilters({
        start,
        end,
        mobile_number,
        name,
        requestNumber,
        deliveryCities,
        equipmentTypeId
      }) {
        end.setHours(24)
        const fromDate = mdy(start);
        const toDate = mdy(end);
        this.$store.commit('setFilters', {
          fromDate,
          toDate,
          mobile_number,
          name,
          requestNumber,
          deliveryCities,
          equipmentTypeId
        });
        this.getSoilTestRequests();
      },
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SoilTests/Home.vue